import { createReducer, on } from '@ngrx/store';
import * as ActivityActions from '../actions/activity.action';
import { PostActivity } from 'src/app/models/PostActivity.model';
import { cloneDeep } from 'lodash';

export interface ActivityState {
  activities: PostActivity[];
  loading: boolean;
  error: any;
}

export const initialState: ActivityState = {
  activities: [],
  loading: false,
  error: null,
};

export const activityReducer = createReducer(
  initialState,
  on(ActivityActions.loadActivities, (state) => ({ ...state, loading: true })),
  on(ActivityActions.loadActivitiesSuccess, (state, { activities }) => ({
    ...state,
    activities,
    loading: false,
  })),
  on(ActivityActions.loadActivitiesFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  on(ActivityActions.addActivity, (state, { activity,production_list }) => { 
    console.log(activity) 
    console.log(production_list) 
    return ({ ...state, loading: true }) }),
  on(ActivityActions.addActivitySuccess, (state, { activity }) => ({
    ...state,
    activities: activity,
    loading: false,
  })),
  on(ActivityActions.addActivityFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  on(ActivityActions.deleteActivity, (state) => ({ ...state, loading: true })),
  on(ActivityActions.deleteActivitySuccess, (state, { activityId, id }) => {
    let activities = cloneDeep(state.activities).map((activity) => {
      if (activity.id === activityId) {
        activity.farm_post_activities = activity.farm_post_activities.filter(
          (a: any) => a.id !== id
        );
      }
      return activity
    })
    return ({
      ...state,
      activities: activities,
      loading: false,
    })
  }),
  on(ActivityActions.deleteActivityFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  }))
);